// Dependencies
import Translate from '@/filters/translate'

// Components
import DropDown from '@/components/dropdown/component'

export default {
  name: 'poster-customization',
  mixins: [ ],
  data () {
    return {
      loaded: false,
      nonLatinWarningNaturalHeight: 0,
      adding: false,
      selectedColor: { name: '', color: '' },
      showCustomizePoster: this.isOpenedByDefault
    }
  },

  props: ['isOpenedByDefault'],

  components: {
    DropDown,

  },

  beforeMount () {

  },

  mounted () {
    let h = this.$el.querySelector('.non-latin-warning').clientHeight
    this.nonLatinWarningNaturalHeight = h
    this.loaded = true
  },

  computed: {
    amPM: {
      set (value) { this.$store.dispatch('setPosterMeridiem', value) },
      get () { return this.$store.getters.posterMeridiem }
    },

    timeFormat: {
      set (value) { this.$store.dispatch('setPosterMeridiem', value === 24 ? '' : 'am') },
      get () { return this.$store.getters.posterMeridiem === '' ? 24 : 12 }
    },

    artistLinkName () {
      // 'Ingela P. Arrhenius' --> 'ingela-p-arrhenius'
      return this.$store.getters.posterArtist.toLowerCase().replace(/[^a-z0-9\s]/ig, '').replace(/\s/g, '-')
    },

    metaData () {
      let allMetaData = this.$store.getters.postersMetaData
      return allMetaData[this.poster] ? allMetaData[this.poster] : {}
    },

    nonLatinWarningHeight () {
      // If we haven't calculated the height yet, allow us to do so.
      if (!this.loaded) {
        return 'auto'
      }

      // Find out if we have characters outside of the Unicode Latin 1 range (U+00FF).
      let nonLatinCharactersInName = false
      this.birthName.split('').forEach(function (c) {
        if (c.charCodeAt() > 255) {
          nonLatinCharactersInName = true
        }
      })

      if (nonLatinCharactersInName) {
        return this.nonLatinWarningNaturalHeight + 'px'
      }
      return '0'
    },

    birthName: {
      set (value) {
        this.$store.dispatch('setPosterChildName', value)
      },
      get () {
        return this.$store.getters.posterChildName
      }
    },

    unit: {
      set (value) {
        this.$store.dispatch('setPosterUnit', value)
      },
      get () {
        return this.$store.getters.posterUnit
      }
    },

    birthLength: {
      set (value) {
        // Commas are considered decimal separators.
        value = value.replace(',', '.')
        this.$store.dispatch('setPosterLength', value)
      },
      get () {
        return this.$store.getters.posterLength
      }
    },

    grams: {
      set (value) {
        let v = this.$store.getters.posterWeight
        v.grams = value.replace(',', '.')
        this.$store.dispatch('setPosterWeight', v)
      },
      get () {
        return this.$store.getters.posterWeight.grams
      }
    },

    lbs: {
      set (value) {
        let v = this.$store.getters.posterWeight
        v.lbs = value.replace(',', '.')
        this.$store.dispatch('setPosterWeight', v)
      },
      get () {
        return this.$store.getters.posterWeight.lbs
      }
    },

    oz: {
      set (value) {
        let v = this.$store.getters.posterWeight
        v.oz = value.replace(',', '.')
        this.$store.dispatch('setPosterWeight', v)
      },
      get () {
        return this.$store.getters.posterWeight.oz
      }
    },

    birthYear: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('year', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.format('YYYY'))
      }
    },

    birthMonth: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.month(value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.month())
      }
    },

    birthDay: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('date', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.date())
      }
    },

    hour: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('hour', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.hour())
      }
    },

    minute: {
      set (value) {
        let v = this.$store.getters.posterBirthDate
        v.set('minute', value)
        this.$store.dispatch('setPosterBirthDate', v)
      },
      get () {
        return parseInt(this.$store.getters.posterBirthDate.minute())
      }
    },

    posterColor: {
      set (value) {
        this.$store.dispatch('setPosterColor', value)
      },
      get () {
        return this.$store.getters.posterColor
      }
    },

    yearValues () {
      let ret = []
      const currentYear = new Date().getFullYear()
      for (let i = currentYear; i > 1949; i -= 1) {
        ret.push({
          name: i,
          value: i,
          preSelected: i === this.birthYear
        })
      }
      return ret
    },

    monthValues () {
      let ret = []
      let self = this

      // Some languages have objects with formats instead of names, such as Russian. If that's the case, use the
      // "standalone" property, otherwise, use the array.
      let months = this.$store.getters.posterBirthDate.localeData().months()

      months.forEach(function (monthName, index) {
        // Make month name start with an upper-case letter.
        let mn = monthName.substr(0, 1).toUpperCase() + monthName.substr(1)

        // Normalize JavaScript's zero-based months.
        let va = index

        // If this value is the month we've currently selected, set it as pre-selected so we don't alter the value in
        // the form if we change languages.
        let ps = index === self.birthMonth

        ret.push({
          name: mn,
          value: va,
          preSelected: ps
        })
      })
      return ret
    },

    // Return 31 items for selecting the day.
    dayValues () {
      let ret = []
      let sv = this.$store.getters.posterBirthDate.date()
      for (let i = 1; i <= 31; i++) {
        ret.push({ name: i, value: i, preSelected: i === sv })
      }
      return ret
    },

    amPMValues () {
      let hours = this.$store.getters.posterBirthDate.hours()
      let ret = [
        {
          name: 'AM',
          value: 'am',
          preSelected: this.amPM === 'am' || hours < 12
        },
        {
          name: 'PM',
          value: 'pm',
          preSelected: this.amPM === 'pm' || hours > 12
        }
      ]
      return ret
    },

    timeFormatValues () {
      // We can't make the comparisons in the object itself, or Vue's watchers can't see the change.
      let ret = [
        { name: '12h', value: 12, preSelected: this.timeFormat === 12 },
        { name: '24h', value: 24, preSelected: this.timeFormat === 24 }
      ]
      return ret
    }
  },

  methods: {
    getTextTranslated (seed) {
      return Translate.translate(seed)
    },

    setPosterLocale (l) {
      this.$store.dispatch('setPosterLocale', l.value)
    },

    setDay (day) {
      this.birthDay = day.value
    },

    setMonth (month) {
      this.birthMonth = month.value
    },

    setYear (year) {
      this.birthYear = year.value
    },

    setTimeFormat (format) {
      switch (format.value) {
        case 12:
        case 24:
          this.timeFormat = format.value
          break
      }
    },

    setAMPM (amPM) {
      switch (amPM.value) {
        case 'am':
        case 'pm':
          this.amPM = amPM.value
          this.$store.dispatch('setPosterMeridiem', this.amPM)
          break
      }
    },

    setPresentation (p) {
      this.$store.dispatch('setPosterPresentation', p.value)
    },

    setPosterColor (color, index) {
      // Set the local color in the generator.
      this.selectedColor = color

      // Update the store with the color index for the poster.
      this.posterColor = index
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/poster-customization/script.js